import { useCallback, useEffect, useMemo, useRef } from "react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import useTrackViAA from "../../../hooks/useTrackViAA.js";
import useIsInViewport from "../../../hooks/useIsInViewport.js";
import { useStickySearchBoxExp } from "../../../utils/experiments/mdotvalue/flights_mdotvalue_sr_sticky_search_box.js";
import web_flights_lve_deal_landing_page from "../../../utils/experiments/lve/web_flights_lve_deal_landing_page.js";
import { shouldTrackFlightDealsHighlightedOfferClick } from "../../../utils/flight-deals.js";
export default function useFlightCardMobileController(props) {
    const { bigLogo, flight, forceHideLastAvailableSeats, index, isAlternativeFareCard, mb, mt, onClick, searchType } = props;
    const i18n = useI18n();
    const { trackScrollToThird, trackScrollToFifth } = useStickySearchBoxExp();
    const ref = useRef(null);
    const isInViewport = useIsInViewport(ref.current);
    const trackViAA = useTrackViAA();
    useEffect(() => {
        trackViAA.ViAAInStage1();
        if (!isInViewport)
            return;
        trackViAA.ViAAInStage2(flight);
    }, [isInViewport, trackViAA, flight]);
    useEffect(() => {
        if (isInViewport && index === 3) {
            trackScrollToThird();
        }
        else if (isInViewport && index === 5) {
            trackScrollToFifth();
        }
    }, [index, isInViewport, trackScrollToFifth, trackScrollToThird]);
    const handleOnClick = useCallback(() => {
        if (shouldTrackFlightDealsHighlightedOfferClick(flight, window.location.search)) {
            web_flights_lve_deal_landing_page.goals.highlighted_offer_clicked_sr();
        }
        trackViAA.ViAAInStage3(flight);
        trackViAA.ViAAInStage4(flight);
        onClick(flight);
    }, [flight, onClick, trackViAA]);
    const ariaLabel = useMemo(() => i18n.trans(t("a11y_flights_search_card_begin")), [i18n]);
    return {
        ariaLabel,
        bigLogo,
        flight,
        forceHideLastAvailableSeats,
        handleOnClick,
        index,
        isAlternativeFareCard,
        mb,
        mt,
        ref,
        searchType
    };
}
